import React from "react";
import FixedAssetsTakeInAccountsGenericSkeleton from "./FixedAssetsTakeInAccountsGenericSkeleton";

function FixedAssetsTakeInAccountsDetailsSkeleton() {
  return (
    <>
      <FixedAssetsTakeInAccountsGenericSkeleton />
    </>
  );
}

export default FixedAssetsTakeInAccountsDetailsSkeleton;
